import React from 'react';
import "./Solution.css";

const Solution = ({ image, title, para }) => {
    const maxCharLimit = 100; // Set the character limit here
    const truncatedPara = para.length > maxCharLimit 
        ? para.substring(0, maxCharLimit) + '...' 
        : para;

    return (
        <div className='solution-container'>
            <img src={image} className='solution-icon' alt='solution icon'/>
            <h1 className='solution-title'>{title}</h1>
            <p className='solution-para'>{truncatedPara}</p>
        </div>
    );
};

export default Solution;
